import { render, staticRenderFns } from "./UpgradeSubscriptionModal.vue?vue&type=template&id=13d4df5b&scoped=true&"
import script from "./UpgradeSubscriptionModal.vue?vue&type=script&lang=js&"
export * from "./UpgradeSubscriptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d4df5b",
  null
  
)

export default component.exports